export const MARKET_MATCH_COLOR_TEMP_MIN_K = 2000;
export const MARKET_MATCH_COLOR_TEMP_MAX_K = 6500;
export const MARKET_MATCH_COLOR_TEMP_STEP_K = 100;

export interface MarketMatchPrefilterRequest {
  manufacturerIds?: number[];
  minColorTemperature?: number;
  maxColorTemperature?: number;
}

export interface MarketMatchPrefilterState {
  selectedManufacturerIds: number[];
  minColorTemperature: number;
  maxColorTemperature: number;
}

export function createDefaultMarketMatchPrefilterState(): MarketMatchPrefilterState {
  return {
    selectedManufacturerIds: [],
    minColorTemperature: MARKET_MATCH_COLOR_TEMP_MIN_K,
    maxColorTemperature: MARKET_MATCH_COLOR_TEMP_MAX_K,
  };
}

export function buildMarketMatchPrefilterRequest(
  manufacturers: { id: number }[],
  state: MarketMatchPrefilterState,
): MarketMatchPrefilterRequest {
  const request: MarketMatchPrefilterRequest = {};
  const allIds = manufacturers.map((m) => m.id);
  const selectedSet = new Set(state.selectedManufacturerIds);
  const allSelected = allIds.length > 0 && allIds.every((id) => selectedSet.has(id));

  if (!allSelected && state.selectedManufacturerIds.length > 0) {
    request.manufacturerIds = [...state.selectedManufacturerIds].sort((a, b) => a - b);
  }

  if (state.minColorTemperature > MARKET_MATCH_COLOR_TEMP_MIN_K) {
    request.minColorTemperature = state.minColorTemperature;
  }

  if (state.maxColorTemperature < MARKET_MATCH_COLOR_TEMP_MAX_K) {
    request.maxColorTemperature = state.maxColorTemperature;
  }

  return request;
}
